import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { navigationItems, NavItem } from '../App';

// Custom hook to update the document title
function usePageTitle() {
  const location = useLocation();

  const getTitle = (navItems: NavItem[], location: string) => {
    navItems.forEach((i: NavItem) => {
      if (i.children) {
        return getTitle(i.children, location);
      }
      if (i.route === location) {
        document.title = 'Lowes Dashboard - ' + (i.shortTitle ?? i.title);
      }
    });
  };

  useEffect(() => {
    getTitle(navigationItems, location.pathname);
  }, [location]); // Update the title whenever the location changes
}

export default usePageTitle;
